module.exports = __webpack_public_path__ + "img/slider_8.b22519a2.jpg";